<template>
  <div
    id="popover-not"
    class="notification tw-h-full tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-mr-2"
  >
    <!-- 铃铛图标 -->
    <div class="tw-text-xl tw-relative">
      <b-icon icon="bell"></b-icon>
      <!-- 未读消息提示 -->
      <span
        v-if="unreadCount > 0"
        class="tw-absolute tw-top-1.5 tw-right-0.5 tw-bg-red-500 tw-text-white tw-font-bold tw-rounded-full tw-w-2 tw-h-2 tw-flex tw-items-center tw-justify-center"
        style="font-size: 8px"
      >
      </span>
    </div>

    <!-- 使用 b-popover 显示公告列表 -->
    <b-popover
      target="popover-not"
      triggers="click"
      placement="top"
      :boundary-padding="0"
      delay="300"
      :hide-on-click-outside="true"
    >
      <div class="bg-white tw-rounded-lg">
        <div
          class="tw-flex tw-justify-between tw-p-4 tw-border-b tw-border-gray-100"
        >
          <div class="tw-text-sm tw-text-textMain tw-font-semibold">
            <span>{{ $t("未读公告") }}</span>
            <span>({{ unreadCount }})</span>
          </div>
          <span
            v-if="unreadCount > 0"
            class="tw-text-xs tw-cursor-pointer hover:tw-text-primary"
            @click="readAllNotice()"
            >{{ $t("全部已读") }}</span
          >
        </div>
        <ul v-if="notifications && notifications.length" class="tw-space-y-2">
          <li
            v-for="(item, index) in notifications"
            :key="index"
            class="tw-p-4 tw-border-b tw-border-gray-100 hover:tw-bg-gray-50 tw-cursor-pointer"
            @click="handleClick(item)"
          >
            <div class="tw-text-sm tw-text-textInfo">{{ item.title }}</div>
            <div class="tw-text-xs tw-text-textDisabled">
              {{ dayjs(item.createdAt).format("YYYY-MM-DD") }}
            </div>
          </li>
        </ul>
        <div
          v-else
          class="tw-p-4 tw-border-b tw-border-gray-100 tw-text-center"
        >
          {{ $t("暂无未读公告") }}
        </div>
        <div class="tw-px-4 tw-py-2 tw-text-right">
          <button
            class="tw-text-textDisabled tw-text-xs hover:tw-text-primary"
            @click="viewMore"
          >
            {{ $t("查看更多") }}
          </button>
        </div>
      </div>
    </b-popover>
  </div>
</template>
<script>
import { getNoticeApi, readAllNoticeApi } from "@/api/personalCenter/index";
import dayjs from "dayjs";
export default {
  name: "notification",
  props: {},
  components: {},
  data() {
    return {
      dayjs,
      notifications: [],
      unreadCount: 0,
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    // 获取未读公告列表
    async getList() {
      const { code, data } = await getNoticeApi();
      if (code !== 0) return;
      this.notifications = data.list;
      this.unreadCount = data.unreadCount;
    }, //全部未读
    async readAllNotice() {
      const { code } = await readAllNoticeApi();
      if (code !== 0) return;
      this.getList();
    },
    handleClick(item) {
      this.$router.push({
        path: `/dynamics/` + item.id,
      });
    },
    viewMore() {
      // 跳转到公告列表页面
      this.$router.push({
        path: `/dynamics/`,
        query: { categoryId: 2 },
      });
    },
    handleClickOutside(e) {
      const popover = document.querySelector(".popover");
      const target = document.getElementById("popover-not");
      if (
        popover &&
        !popover.contains(e.target) &&
        target !== e.target &&
        !target.contains(e.target)
      ) {
        this.$root.$emit("bv::hide::popover", "popover-not");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  position: relative;
}
.b-popover {
  width: 271px !important;
  top: 20px !important;
  left: -10px !important;
  border: none !important;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.08) !important;
  z-index: 99999;
}
::v-deep .popover-body {
  padding: 0 !important;
}
::v-deep .arrow::before {
  border-bottom-color: transparent !important;
}
::v-deep .arrow::after {
  border-width: 0 !important;
}
</style>
